import { Init } from "@pdfking/reactivity/preact"
import {
  contains,
  delete_duplicates,
  filter,
  group_by,
  length,
  map,
  object_map,
  to_array,
} from "@pdfking/rfunc"
import {
  CreateSingleton,
  Identity,
  KeyDrop,
  Keys,
  SortBy,
} from "@pdfking/tfunc"
import fire_event from "@pdfking/workflow/utils/fire_event"
import CreateStorage from "../files/providers/create"
import { DefaultBackend } from "../files/storage/DefaultBackend"
import persistence from "../utils/persistence"

const store = persistence("storage")

export default CreateSingleton(() =>
  Init({
    computed: {
      all_files_checked: {
        get() {
          const s = length(this.selected_files)
          const t = length(this.files)
          return s == t && t > 0
        },
        set(v) {
          this.unselected_files_names = v ? [] : Keys(this.files)
        },
      },
      files() {
        return this.provider?.files || {}
      },
      files_by_id() {
        return group_by(this.files, f => f.id)
      },
      selected_files() {
        return KeyDrop(this.files, this.unselected_files_names)
      },

      selected_files_names: {
        get() {
          return SortBy(Keys(this.selected_files))
        },
        set(v) {
          this.unselected_files_names = Keys(KeyDrop(this.files, v))
        },
      },
    },
    data: {
      config: {},
      last_session: null,
      provider: {} as Record<string, any>,
      unselected_files_names: [],
    },
    methods: {
      ...object_map(
        Identity,
        k =>
          function (...input) {
            const callback =
              // @ts-expect-error TS2683
              this.provider[k] ||
              (async (...args) => console.info("unhandled", k, ...args))
            return Promise.resolve(callback(...input)).catch(error =>
              fire_event(document, "tracked_error", error)
            )
          },
        [
          "open_files",
          "open_folders",
          "add_files",
          "remove_files",
          "refresh",
          "cleanup",
        ] as const
      ),
      select_files(files) {
        this.selected_files_names = delete_duplicates(
          to_array(
            this.selected_files_names,
            map(f => f.id, to_array(files))
          )
        )
        return files
      },
      set_config(spec, no_store = false) {
        const config = spec || DefaultBackend
        CreateStorage(config).then(provider => {
          this.config = config
          this.provider = provider
          if (!no_store) store.set(config)
          provider.populate()
        })
      },
      unselect_files(files) {
        this.selected_files_names = filter(
          k => !contains(files, k),
          this.selected_files_names
        )
        return files
      },
    },
    init() {
      store.get().then(config => this.set_config(config, true))
    },
  })
)
